import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { FaStar } from "react-icons/fa";
import "swiper/css";
import "swiper/css/pagination";
import "./testimonial.css";

import img from "../../assets/testionial/img.png";

const testimonials = [
  {
    id: 1,
    name: "New Sky Property",
    rating: 3,
    review:
      "Electiaa transformed our outdated website into a modern, mobile-friendly platform that truly reflects our brand. Their attention to detail, creativity, and responsiveness exceeded our expectations. Highly recommended!",
    img: img,
  },
  {
    id: 2,
    name: "First Sky Infra",
    rating: 4,
    review:
      "Working with Electiaa was an absolute pleasure. They listened to our needs, delivered on time, and created a stunning website that has improved our online visibility. A professional team with great design sense!",
    img: img,
  },
  {
    id: 3,
    name: "HiTech Fibre",
    rating: 5,
    review:
      "From concept to launch, Electiaa handled our project with professionalism and care. The design is sleek, fast, and user-friendly. We have received so many compliments from our customers!",
    img: img,
  },
  {
    id: 4,
    name: "Redite",
    rating: 5,
    review:
      "Electiaa team is creative, reliable, and very responsive. They gave our website a fresh look that boosted engagement and helped us stand out in a competitive market.",
    img: img,
  },
  {
    id: 5,
    name: "Triplette",
    rating: 4,
    review:
      "We needed a website that was clean, modern, and easy to navigate. Electiaa delivered exactly that—and more. Their post-launch support is also excellent!",
    img: img,
  },
];

function TestimonialSlider() {
  return (
    <section className="testimonial-section">
      <center>
        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Testimonial</h2>
          </div>
        </section>
      </center>

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        slidesPerView={3}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        className="testimonial-swiper"
      >
        {testimonials.map((t) => (
          <SwiperSlide key={t.id}>
            <div className="testimonial-card">
              <img src={t.img} alt={t.name} className="testimonial-img" />
              <p>{t.review}</p>
              <h3 className="testimonial-name">- {t.name}</h3>
              <div className="stars">
                {Array.from({ length: 5 }, (_, i) => (
                  <FaStar key={i} color={i < t.rating ? "gold" : "#ccc"} />
                ))}
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default TestimonialSlider;
